import PlyLayerShopFloorDataViewer from './PlyLayerShopFloorDataViewer'
import PlyLayerShopFloorLink from './attributes/PlyLayerShopFloorLink'
import PlyLayerShopFloorLinkRenderer from './attributes/PlyLayerShopFloorLinkRenderer'

export default {
  install( molten ) {
    molten.addPlugin( 'DataViewer', PlyLayerShopFloorDataViewer )
    molten.addPlugin( 'Attribute', PlyLayerShopFloorLink )
    molten.addPlugin( 'AttributeCellRenderer', PlyLayerShopFloorLinkRenderer )
    molten.addPlugin( 'AttributeValueRenderer', PlyLayerShopFloorLinkRenderer )
  }
}
